// Copyright 2019 Drivetrain Hub LLC
// Configure external URLs for use throughout Vue app.
// URLs dependent on environment make use of .env files.
// https://vuejs.org/v2/guide/plugins.html

// Cannot type hint PluginObject without losing variable resolution.
// eslint-disable-next-line no-unused-vars
import { PluginFunction } from "vue";

const SITE_HOST = process.env.VUE_APP_HOST_SITE;
const USER_BLUEPRINT = `${SITE_HOST}/user`;
const SUPPORT_URL = `${SITE_HOST}/support`;  // support SSO and redirect; do not use support.drivetrainhub.com
const HELP_DOMAIN = "https://help.drivetrainhub.com";  // PLACEHOLDER domain of help menus
const CLOUD_STORAGE_STATIC = "https://storage.googleapis.com/static.drivetrainhub.com";

function getSigninUrl() {
  if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_DEV_SIGNIN
  } else {
    return `${USER_BLUEPRINT}/signin`
  }
}

function getSignoutUrl() {
  if (process.env.NODE_ENV === 'development') {
    return process.env.VUE_APP_DEV_SIGNOUT
  } else {
    return `${USER_BLUEPRINT}/signout`
  }
}

/** @alias $urls */
const Urls = {
  DH_LOGO_128: `${CLOUD_STORAGE_STATIC}/img/dh_logo_333333_128x128.png`,
  DH_LOGO_256: `${CLOUD_STORAGE_STATIC}/img/dh_logo_333333_256x256.png`,
  APP_HOME: process.env.VUE_APP_HOST,
  // SITE
  SITE_HOME: SITE_HOST,
  SITE_MEMBERSHIPS: `${SITE_HOST}/membership`,
  SITE_CONSULTING_RFQ: `${SITE_HOST}/consultants/rfq`,
  // USER
  USER_BLUEPRINT: USER_BLUEPRINT,
  USER_SIGNIN: getSigninUrl(),
  USER_SIGNOUT: getSignoutUrl(),
  USER_PROFILE: `${USER_BLUEPRINT}/profile`,
  USER_PASSWORD_RESET: `${USER_BLUEPRINT}/reset`,
  USER_ACCOUNT: `${USER_BLUEPRINT}/account`,
  USER_ACCOUNT_USERS: `${USER_BLUEPRINT}/account/users`,
  USER_ACCOUNT_BILLING: `${USER_BLUEPRINT}/account/billing`,
  // SUPPORT
  SUPPORT_HOME: `${SUPPORT_URL}/home`,
  SUPPORT_SOLUTIONS: `${SUPPORT_URL}/solutions`,
  SUPPORT_FORUMS: `${SUPPORT_URL}/discussions`,
  SUPPORT_TICKETS: `${SUPPORT_URL}/tickets`,
  SUPPORT_TUTORIALS: `${SUPPORT_URL}/solutions/48000453289`,
  SUPPORT_FAQ: `${SUPPORT_URL}/solutions/folders/48000112835`,
  // HELP
  // PLACEHOLDER {help} update URLs for feature-specific help buttons
  HELP_SHARE: `${HELP_DOMAIN}/share`,
  HELP_ATTACHMENTS: `${HELP_DOMAIN}/attachments`,
  HELP_REFERENCES: `${HELP_DOMAIN}/references`,
  HELP_REPORTS: `${HELP_DOMAIN}/reports`,
  HELP_MODEL_INFO: `${HELP_DOMAIN}/model info`,
  HELP_MODEL_FILES: `${HELP_DOMAIN}/model files`,
  HELP_MODEL_RELEASES: `${HELP_DOMAIN}/model releases`,
  HELP_MODEL_HOB: `${HELP_DOMAIN}/modeler/hob`,
  HELP_MODEL_SHAPER: `${HELP_DOMAIN}/modeler/shaper`,
  HELP_MODEL_BASIC_RACK: `${HELP_DOMAIN}/modeler/basic rack`,
  HELP_MODEL_GEAR: `${HELP_DOMAIN}/modeler/gear`,
  HELP_MODEL_CARRIER: `${HELP_DOMAIN}/modeler/carrier`,
  HELP_MODEL_MICRO: `${HELP_DOMAIN}/modeler/microgeometry`,
  HELP_MODEL_PROPS: `${HELP_DOMAIN}/modeler/properties`,
  HELP_LIB_GEAR: `${HELP_DOMAIN}/library/gear`,
  HELP_LIB_TOOL: `${HELP_DOMAIN}/library/tool`,
  HELP_LIB_MATERIAL: `${HELP_DOMAIN}/library/material`,
  HELP_LIB_QUALITY: `${HELP_DOMAIN}/library/quality`,
  HELP_ASSM_POSITION: `${HELP_DOMAIN}/assemble/position`,
  HELP_ASSM_CONNECT: `${HELP_DOMAIN}/assemble/connect`,
  HELP_EXP_CAD: `${HELP_DOMAIN}/export/cad`,
  HELP_EXP_FE: `${HELP_DOMAIN}/export/fe`,
  HELP_EXP_STL: `${HELP_DOMAIN}/export/stl`,
  HELP_EXP_DATA: `${HELP_DOMAIN}/export/data`,
  HELP_SETUP_CONFIG: `${HELP_DOMAIN}/analysis/config`,
  HELP_SETUP_SETTINGS: `${HELP_DOMAIN}/analysis/settings`,
  HELP_SETUP_DUTY_CYCLES: `${HELP_DOMAIN}/analysis/duty cycles`,
  HELP_SETUP_LOAD_CASES: `${HELP_DOMAIN}/analysis/load cases`,
  HELP_RUN_POWERFLOW: `${HELP_DOMAIN}/analysis/powerflow`,
  HELP_BUILD_PRINT: `${HELP_DOMAIN}/build/print3d`,
  HELP_BUILD_MFG: `${HELP_DOMAIN}/build/manufacture`,
  HELP_DRAWING: `${HELP_DOMAIN}/build/drawing`,
};

/** @type {PluginFunction} */
Urls.install = function(Vue) {
  Vue.prototype.$urls = Urls;
};

export default Urls
